import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import { callApi, fnSave } from "@shared/api/restApi";
import { menuInfo } from "@shared/type/CommonType";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { showDialog } from "@widgets/CommonDialog";
import SnGrid from "@shared/components/Grid/SnGrid";
import SnButton from "@shared/components/SnButton";

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string;

  [key: string]: any;
}

const SN_SAL_BAS_REG_005 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region Component UseState
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any[]>([]);
  const [dataSource1, setDataSource1] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [gridFocus, setGridFocus] = useState(false);
  //#endregion

  //#region Variables
  const gridref1 = useRef<any>(null);
  const { userInfo } = global();
  let SaveData: any = {};
  const searchRef = useRef<any>(null);
  let btnClick = false;
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setColums(rtn.grid.grid1);
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    gridref1.current.selectAndFocusRow(0);
    setGridFocus(false);
  }, [gridFocus]);

  //#region Bottom Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onDelete,
  }));

  const onSearch = async () => {
    // const modifiedRowsH = gridref1.current.getChange();
    // if (modifiedRowsH.modifiedRowcount > 0) {
    //   const confirm = await showDialog(
    //     "confirm",
    //     "수정된 내용이 있습니다. 저장하시겠습니까?"
    //   );
    //   if (confirm) {
    //     await onSave();
    //   }
    // }
    try {
      const params = {
        id: "sn_sal_bas_reg_005_01",
        params: searchRef.current.getFormdata(),
      };

      setDataSource1([]);
      const data: any = await fnGetDataSet(params);
      setDataSource1(data[0]);
      if (data[0] && data[0].length > 0) {
        await new Promise((resolve) => setTimeout(resolve, 50)); // 비동기 반영 대기 (최적화 가능)
        setGridFocus(true);
      }

      gridref1.current.resetUpdate();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };
  const onDelete = async () => {
    const gridApiH = gridref1.current.api;
    const rowCount = gridApiH.getDisplayedRowCount();
    if (rowCount === 0) {
      return;
    }

    const confirm = await showDialog("confirm", "삭제하시겠습니까?");

    if (!confirm) {
      return;
    }

    const params = {
      cd_firm: userInfo.cd_firm,
      ym: searchRef.current.getFormdata().yy,
    };
    const result: any = await callApi("SN_SAL_BAS_REG_005_OnDelete", params);
    if (result) {
      gridref1.current?.deleteAllRows();
      gridref1.current.resetUpdate();
    }
  };

  const gridref1btnclick = async (id: string) => {
    if (id == "btn") {
      const current_yr = searchRef.current.getFormdata();
      const date = current_yr?.yy
        ? parseInt(current_yr.yy.substring(0, 4), 10) + 1
        : NaN;
      const next_yr = date + "00";

      const searchParam = {
        cd_firm: userInfo.cd_firm,
        yy: next_yr,
        gubun: current_yr.gubun,
      };

      const newParam = {
        id: "sn_sal_bas_reg_005_02",
        params: { ...searchParam },
      };
      const data: any = await fnGetDataSet(newParam);
      if (data[0] && data[0].length > 0) {
        const confirm = await showDialog(
          "confirm",
          "처리된 데이터가 이미 존재합니다. 계속하시겠습니까?"
        );
        if (confirm) {
          const SaveData = {
            sal_ar: { delete: data[0] },
          };
          await fnSave("SN_SAL_BAS_REG_005_SAVE_01", SaveData);
        } else {
          return;
        }
      }

      const getRenderedNodes = gridref1.current.api.getRenderedNodes(); //
      const virtualTable = [];
      for (const node of getRenderedNodes) {
        const newValue = {
          cd_firm: userInfo.cd_firm,
          ym: next_yr,
          cd_spare: "*",
          cd_cust: node.data?.cd_cust,
          fg_trns: node.data?.fg_trns,
          cd_exch: node.data?.cd_exch,
          am_ar: node.data?.am_ar,
          am_ar_isu: node.data?.am_ar_isu,
          am_col_a: node.data?.am_col_a,
        };

        virtualTable.push(newValue);
      }
      const SaveData = {
        sal_ar: { insert: virtualTable },
      };
      await fnSave("SN_SAL_BAS_REG_005_SAVE_01", SaveData);
      gridref1.current.resetUpdate();
    }
  };

  // const onSave = async () => {
  //   try {
  //     gridref1.current.api.stopEditing();
  //     const requiredValuesCheck = gridref1.current.requiredValuesCheck();
  //     if (!requiredValuesCheck) {
  //       return;
  //     }

  //     const gridGetChanges = gridref1.current.getChange();
  //     if (gridGetChanges.modifiedRowcount == 0) {
  //       await showDialog("error", "변경된 내용이 없습니다.");
  //       return;
  //     }

  //     SaveData["sal_ar"] = gridref1.current.getChange();
  //     await fnSave("SN_SAL_BAS_REG_005_SAVE_01", SaveData);
  //     gridref1.current.resetUpdate();
  //     SaveData = [];
  //   } catch (error: any) {}
  // };
  //#endregion

  //#region UI
  return (
    <div className="h-full flex flex-col">
      <div>
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        ></SearchPanel>
      </div>
      <div className="flex-1 h-full w-full">
        <SnGrid
          seq={1}
          ref={gridref1}
          
          enableAddRow={true}
          columnConfig={columns} // 컬럼 설정 전달
          rowData={dataSource1}
          enableExternalChart={false}
          isEditable={false}
          rowSelection="single" // 단일 선택 모드
          cellSelection={true}
          title=" "
          header={
            <div>
              <SnButton
                text="이월처리"
                onClick={() => {
                  gridref1btnclick("btn");
                }}
              ></SnButton>
            </div>
          }
        />
      </div>
    </div>
  );
  //#endregion
});

export default SN_SAL_BAS_REG_005;
